'use client'

import type { NavigationHeaderProps } from '@maestro/commerce-blocks/components/navigation-header/navigation-header.types'

import {
  NavigationFoldout,
  NavigationFoldoutToggleButton,
  NavigationMobile,
} from '@maestro/commerce-blocks/components/navigation-header'
import { useNavigationHeaderFoldout } from '@maestro/commerce-blocks/components/navigation-header/batons/use-navigation-header-foldout'

export default function NavigationHeaderFoldout(props: NavigationHeaderProps) {
  const { customClassName, menu, shortcuts } = props
  const { closeMenu, isOpen, isDesktop } = useNavigationHeaderFoldout()

  return (
    <>
      <NavigationFoldoutToggleButton customClassName={customClassName} />
      {isDesktop ? (
        // Desktop foldout intentionally has no shortcuts.
        <NavigationFoldout menu={menu} />
      ) : (
        // Mobile uses the standard menu, including shortcuts.
        <NavigationMobile
          closeMenu={closeMenu}
          menu={menu}
          shortcuts={shortcuts}
          isOpen={isOpen}
        />
      )}
    </>
  )
}
